export const dashboardRoutes = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      icon: "chart-line",
      active: true,
      to: "/dashboard",
    },
    {
      name: "Settings",
      to: "/settings",
      active: true,
      icon: "cog",
    },

  ],
};

export default [dashboardRoutes];
